
import { defineComponent } from 'vue';

import TheDetailPageHeader from '@/components/organisms/detailPage/TheDetailPageHeader.vue';
import TheDetailPageBody from '@/components/organisms/detailPage/TheDetailPageBody.vue';
import LinkButton from '@/components/organisms/utils/LinkButton.vue';
import Heading from '@/components/atoms/Heading.vue';
import SignalText from '@/components/atoms/SignalText.vue';

export default defineComponent({
  name: 'AccessTemplate',
  components: {
    TheDetailPageHeader,
    TheDetailPageBody,
    LinkButton,
    Heading,
    SignalText,
  },
  props: {
    i18n: {
      type: Object,
    },
  },
});
